import { useEffect, useState } from "react";

export const useIsTouchDevice = () => {
    const [isTouch, setIsTouch] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const mq = window.matchMedia?.("(pointer: coarse)");
        const update = () => setIsTouch(Boolean(mq?.matches) || "ontouchstart" in window);

        update();
        mq?.addEventListener?.("change", update);
        return () => mq?.removeEventListener?.("change", update);
    }, []);

    return isTouch;
};
